// ============================================================
// Datei: src/pages/ressorts/food/FoodDesktop.jsx
//
// 🔥 ÄNDERUNGEN:
// - GuestList Props ergänzt (refreshGuestList)
// - Verhalten 100% identisch zu anderen Ressorts
// - ShiftTable jetzt mit departmentName + filterFn
// - dadurch bleiben Aufbau / Festival / Abbau sauber getrennt
// - automatische Aktualisierung bleibt erhalten
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import ShiftTable from "../../../components/shiftTable/ShiftTable";
import EditVolunteerModal from "../../../components/EditVolunteerModal";

// ================= GUESTS =================
import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";
import VolunteerPool from "../../../components/VolunteerPool";

import "./food.css";

const FoodDesktop = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	selectedVolunteer,
	setSelectedVolunteer,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers
}) => {
	// ============================================================
	// STATE
	// ============================================================
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);

	// ============================================================
	// SHIFTS
	// ============================================================
	const foodFestival = shifts.filter((s) => s.shiftId >= 401 && s.shiftId <= 419);
	const foodZmorge = shifts.filter((s) => s.shiftId >= 420 && s.shiftId <= 429);
	const foodAufbau = shifts.filter((s) => s.shiftId >= 430 && s.shiftId <= 459);
	const foodAbbau = shifts.filter((s) => s.shiftId >= 460 && s.shiftId <= 479);

	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{/* ================= HELPERS ================= */}
					{activeTab === "helpers" && (
						<div className="helpers-layout">
							<div className="helpers-column helpers-column-left">
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={(v) => setSelectedVolunteer(v)}
									reloadVolunteers={reloadVolunteers}
								/>
							</div>

							<div className="helpers-column helpers-column-right">
								<VolunteerPool
									departmentName="Food"
									onAssigned={() => {
										if (reloadVolunteers) reloadVolunteers();
									}}
								/>
							</div>
						</div>
					)}

					{/* ================= SHIFTS ================= */}

					{activeTab === "shifts" && (
						<>
						{/*	<h3 className="food-subheading">Aufbau</h3>
							<ShiftTable
								shifts={foodAufbau}
								departmentName="Food"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 430 && shift.shiftId <= 459}
							/>
						*/}

							<h3 className="food-subheading">Festival</h3>
							<ShiftTable
								shifts={foodFestival}
								departmentName="Food"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 401 && shift.shiftId <= 410}
							/>

							<h3 className="food-subheading">Zmorge</h3>
							<ShiftTable
								shifts={foodZmorge}
								departmentName="Food"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 420 && shift.shiftId <= 429}
							/>

						{/*	<h3 className="food-subheading">Abbau</h3>
							<ShiftTable
								shifts={foodAbbau}
								departmentName="Food"
								autoRefresh={true}
								filterFn={(shift) => shift.shiftId >= 460 && shift.shiftId <= 479}
							/>
						*/}
						</>
					)}
					{/* ================= GUESTS ================= */}
					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}
				</div>
			</div>

			{/* ================= EDIT VOLUNTEER ================= */}
			{selectedVolunteer && (
				<EditVolunteerModal
					volunteer={selectedVolunteer}
					onClose={() => setSelectedVolunteer(null)}
					onSaved={() => reloadVolunteers?.()}
				/>
			)}

			{/* ================= EDIT GUEST ================= */}
			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{/* ================= DELETE GUEST ================= */}
			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default FoodDesktop;